import Network from '@/services/network'

export default function () {
    const network = new Network;

    const fetchLocationList = (query) => {
        return network.api('get', '/locations'+query);
    }
    const fetchDropdownLocationList = (query) => {
        return network.api('get', '/dropdown-location'+query);
    }
    const storeLocation = (data, query) => {
        return network.api('post', '/locations'+query, data);
    }
    const fetchSingleLocation = (locationId, query) => {
        return network.api('get', '/locations/' + locationId + query);
    }
    const updateLocation = (data, locationId, query) => {
        return network.api('put', '/locations/'+ locationId + query, data);
    }
    const fetchParentLocationList = (query) => {
        return network.api('get', '/parent-location'+query);
    }

    return {
        fetchLocationList,
        fetchParentLocationList,
        storeLocation,
        updateLocation,
        fetchSingleLocation,
        fetchDropdownLocationList
    }
}